<template>
  <v-menu offset-y z-index="200">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        :data-test="AutomationTestsIds.navigationUserButton"
        class="user-button white-border w-full fade-icon-button text-capitalize justify-start px-2"
        outlined>
        <v-row no-gutters>
          <v-col class="shrink">
            <v-avatar v-if="$user?.photoUrl" size="24"><v-img :src="optimizeAvatar($user.photoUrl, 24)"/></v-avatar>
            <v-icon v-else>mdi-account-circle</v-icon>
          </v-col>
          <template v-if="!icon">
            <v-col class="grow text-left pl-4 text-truncate">
              <span>{{name}}</span>
            </v-col>
            <v-col class="shrink">
              <v-icon right>keyboard_arrow_down</v-icon>
            </v-col>
          </template>
        </v-row>
      </v-btn>
    </template>
    <slot name="menu" />
  </v-menu>
</template>

<script setup lang="ts">
import { useInstance } from '@/composables/useInstance';
import { useImageOptimize } from '@/composables/useImageOptimize';
import { AutomationTestsIds } from '@/env/AutomationTests/ids/AutomationTestsIds';
type UserButtonProps = {
  name: string,
  icon: boolean,
}

const props = withDefaults(defineProps<UserButtonProps>(), {
  icon: true,
});

const { $user, } = useInstance();
const { optimizeAvatar } = useImageOptimize();

</script>

<style scoped lang="scss">
.user-button {
  ::v-deep .v-btn__content {
    width: 100%;
  }
}
</style>
